import React, { MouseEventHandler, useCallback } from 'react';

import { EventBus, LangUri } from '@catawiki/runtime-toolkit';

import { isInMobileApp } from '../utils/isInMobileApp';

type RegistrationHandlersProps<T extends HTMLElement> = {
  onSignInClick?: MouseEventHandler<T>;
  onSignUpClick?: MouseEventHandler<T>;
};

const handleMobileLogin = () => {
  const location = window.location.href;
  const uri = LangUri.LangUri.of(location);
  window.open(
    `${uri.generatePath(
      '/accounts/login',
      true
    )}?redirect_after=${encodeURIComponent(location)}`
  );
};

export const useRegistrationHandlers = <T extends HTMLElement>({
  onSignInClick,
  onSignUpClick,
}: RegistrationHandlersProps<T> = {}) => {
  const onSignUpHandler = useCallback(
    (event: React.MouseEvent<T>) => {
      event.preventDefault();
      if (isInMobileApp()) {
        handleMobileLogin();
        return;
      }

      EventBus.showScreen({
        screen: EventBus.Screen.SIGN_UP,
      });

      onSignUpClick?.(event);
    },
    [onSignUpClick]
  );

  const onSignInHandler = useCallback(
    (event: React.MouseEvent<T>) => {
      event.preventDefault();
      if (isInMobileApp()) {
        handleMobileLogin();
        return;
      }

      EventBus.showScreen({
        screen: EventBus.Screen.SIGN_IN,
      });

      onSignInClick?.(event);
    },
    [onSignInClick]
  );

  return {
    onSignInHandler,
    onSignUpHandler,
  };
};
